import PresetAndCustomColorPicker from "components/colorpicker/PresetAndCustomColorPicker";
import React, { useEffect, useRef } from "react";
import "./colorPickerDropdown.scss";

interface IColorPickerDropdownProps {
  isDropdownOpen: boolean;
  setIsDropdownOpen: (isDropdownOpen: boolean) => void;
  onChange: (color: string) => void;
  selectedColor?: string;
  children: React.ReactNode;
}

export function ColorPickerDropdown(props: IColorPickerDropdownProps) {
  const { isDropdownOpen, setIsDropdownOpen, onChange, selectedColor, children } = props;
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideDropdownClick);
    document.addEventListener("touchstart", handleOutsideDropdownClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideDropdownClick);
      document.removeEventListener("touchstart", handleOutsideDropdownClick);
    };
  }, []);

  function handleOutsideDropdownClick(event: MouseEvent | TouchEvent) {
    const target = event.target;
    if (!(target instanceof Node)) {
      return;
    }

    const clickedInsideDropdown = dropdownRef.current?.contains(target) ?? false;
    const clickedInsideCustomPopup = target instanceof Element && target.closest(".color-picker-popup") != null;
    if (clickedInsideDropdown || clickedInsideCustomPopup) {
      return;
    }

    setIsDropdownOpen(false);
  }

  return (
    <div ref={dropdownRef} className="color-picker-dropdown">
      {children}
      <div style={{ display: isDropdownOpen ? "block" : "none" }} className="color-picker-dropdown-content">
        <PresetAndCustomColorPicker
          colorValue={selectedColor ?? ""}
          onChange={updatedHexColor => {
            if (updatedHexColor) {
              onChange(updatedHexColor);
            }
          }}
          compact
          portalParentId="portal-root"
        />
      </div>
    </div>
  );
}
